import { formatRelativeTime } from './sessions/utils';
import { useAssistantContext } from './AssistantProvider';

const ChatHistory = ({ onBack }) => {
    const { activeChatId, sessions, switchToSession } = useAssistantContext();

    const handleSelect = (id) => {
        switchToSession(id);
        onBack();
    };

    return (
        <div className="flex-1 overflow-y-auto px-4 pt-6">
            {sessions && sessions.length > 0 ? (
                <div className="flex flex-col gap-1">
                    {sessions.map((session) => (
                        <button
                            key={session.id}
                            type="button"
                            onClick={() => handleSelect(session.id)}
                            className={`group flex flex-col gap-0.5 px-3 py-3 rounded-xl text-left transition-colors w-full cursor-pointer ${
                                session.id === activeChatId
                                    ? 'bg-violet-50 border border-violet-200'
                                    : 'bg-transparent border border-transparent hover:bg-muted'
                            }`}
                        >
                            <span className="text-sm font-medium text-foreground truncate">
                                {session.label}
                            </span>
                            <span className="text-xs text-muted-foreground">
                                {formatRelativeTime(session.updatedAt)}
                            </span>
                        </button>
                    ))}
                </div>
            ) : (
                <div className="flex-1 flex items-center justify-center text-sm text-muted-foreground py-12">
                    No previous chats
                </div>
            )}
        </div>
    );
};

export default ChatHistory;
